import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiUrlService {
  SEND_MAIL = `${environment.BASE_URL}users/onboarding/request`;
  VERIFY_EMAIL = `${environment.BASE_URL}users/verifyotp/request`;
  SET_PASSWORD = `${environment.BASE_URL}users/verifyotp/updateorganization`;
  RESEND_OTP = `${environment.BASE_URL}users/verifyotp/resend-otp`;
  constructor() { }

  // USER RELATED APIS

  ADMIN_LOGIN = `${environment.BASE_URL}auth/login`;
  // ADMIN_LOGIN = `${environment.BASE_URL}admin/user/login`;

  FETCH_USER = `${environment.BASE_URL}auth/users`;
  CREATE_USER = `${environment.BASE_URL}admin/user/create`;
  UPDATE_ADMIN_USER_BYID = `${environment.BASE_URL}admin/user/update`;
  GET_USER_PROFILE = `${environment.BASE_URL}admin/user/profile`;
  FORGET_PASSWORD = `${environment.BASE_URL}users/password-reset/request`;
  RESET_PASSWORD = `${environment.BASE_URL}users/update/reset-password`;
  TOKEN_VALIDATE = `${environment.BASE_URL}users/validate-request`;
  UPDATE_PASSWORD = `${environment.BASE_URL}users/change-password`;
  GET_USER_LIST_PAGINATION = `${environment.BASE_URL}admin/user/get_with_paginate`;
  GET_MEMBER_LIST_PAGINATION = `${environment.BASE_URL}admin/user/service_manager/get_with_paginate`;
  GET_USER_DETAILS = `${environment.BASE_URL}admin/user`;
  UPDATE_USER_DETAILS = `${environment.BASE_URL}admin/user/update`;
  // VIEW PROSILE
  VIEW_PROFILE = `${environment.BASE_URL}users/profile`;

  // DASHBOARD
  GET_DASHBOARD = `${environment.BASE_URL}admin/charts`;
  GET_SUMMARY = `${environment.BASE_URL}admin/summary`;

  // WALLET
  GET_WALLET = `${environment.BASE_URL}admin/wallet/get_with_paginate`;
  GET_WALLET1 = `${environment.BASE_URL}admin/wallet/info`;
  ADJUST_WALLET = `${environment.BASE_URL}admin/wallet/settlement`;

  // ADMIN CHART

  GET_WALLET_CHART = `${environment.BASE_URL}admin/wallet/chart`;

  // Admin-Chart
  GET_DASHBOARD_CHART = `${environment.BASE_URL}admin/dashboard`;

  // CUSTOMER RELATED APIS

  GET_CUSTOMERS = `${environment.BASE_URL}admin/customer/get_with_paginate`;
  GET_CUSTOMER_DETAILS = `${environment.BASE_URL}admin/customer`;
  CREATE_CUSTOMER = `${environment.BASE_URL}admin/customer/create`;
  UPDATE_CUSTOMER = `${environment.BASE_URL}admin/customer/update`;
  DELETE_CUSTOMER = `${environment.BASE_URL}admin/customer/delete`;

  // API CATALOGUE RELATED APIS

  GET_API_CATALOGUE = `${environment.BASE_URL}admin/apiCatalogue/get_with_paginate`;
  GET_API_CATALOGUE_DETAILS = `${environment.BASE_URL}admin/apiCatalogue`;
  CREATE_API_CATALOGUE = `${environment.BASE_URL}admin/apiCatalogue/create`;
  UPDATE_API_CATALOGUE = `${environment.BASE_URL}admin/apiCatalogue/update`;
  DELETE_API_CATALOGUE = `${environment.BASE_URL}admin/apiCatalogue/delete`;

  // ROLE RELATED APIS

  GET_ADMIN_ROLES = `${environment.BASE_URL}admin/roles/get_with_paginate`;
  GET_ROLE_DETAILS = `${environment.BASE_URL}admin/roles`;
  CREATE_ROLE = `${environment.BASE_URL}admin/roles/create`;
  UPDATE_ROLE = `${environment.BASE_URL}admin/roles/update`;
  DELETE_ROLE = `${environment.BASE_URL}admin/roles/delete`;

  // CREATE PERMISSION & CATEGORY FOR PERMISSION SETUP
  CREATE_PERMISSION_SETUP = `${environment.BASE_URL}admin/permission/create`;
  CREATE_CATEGORY_SETUP = `${environment.BASE_URL}admin/category/create`;
  GET_CATEGORY_SETUP = `${environment.BASE_URL}admin/category/get_with_paginate`;
  UPDATE_CATEGORY = `${environment.BASE_URL}admin/category/update`;
  DELETE_CATEGORY = `${environment.BASE_URL}admin/category/delete`;

  // INDUSTRY TYPE RELATED APIS
  GET_INDUSTRY_TYPE = `${environment.BASE_URL}admin/industryType/get_with_paginate`;
  GET_INDUSTRY_TYPE_DETAILS = `${environment.BASE_URL}admin/industryType`;
  CREATE_INDUSTRY_TYPE = `${environment.BASE_URL}admin/industryType/create`;
  UPDATE_INDUSTRY_TYPE = `${environment.BASE_URL}admin/industryType/update`;
  DELETE_INDUSTRY_TYPE = `${environment.BASE_URL}admin/industryType/delete`;

  // SERVICE MANAGER RELATED APIS
  GET_SERVICE_MANAGER = `${environment.BASE_URL}admin/serviceManager/get_with_paginate`;
  GET_DETAIL_SERVICE_MANAGER = `${environment.BASE_URL}admin/serviceManager`;
  CREATE_SERVICE_MANAGER = `${environment.BASE_URL}admin/serviceManager/create`;
  UPDATE_SERVICE_MANAGER = `${environment.BASE_URL}admin/serviceManager/update`;
  DELETE_SERVICE_MANAGER = `${environment.BASE_URL}admin/serviceManager/delete`;
  GET_SUPPORT_COUNT = `${environment.BASE_URL}admin/serviceManager/get_count`;
  ALL_SUPPORT_USER = `${environment.BASE_URL}admin/user/allEmployeesWithPermission?permission=service-request-status_update,service-request-view`;

  // API MANAGER RELATED APIS
  GET_API_MANAGERS = `${environment.BASE_URL}admin/apiManager/get_with_paginate`;
  GET_DETAIL_API_MANAGER = `${environment.BASE_URL}admin/apiManager`;
  CREATE_API_MANAGER = `${environment.BASE_URL}admin/apiManager/create`;
  UPDATE_API_MANAGER = `${environment.BASE_URL}admin/apiManager/update`;
  DELETE_API_MANAGER = `${environment.BASE_URL}admin/apiManager/delete`;

  // state url
  BASE_STATE = `${environment.BASE_URL}admin/state`;
  BASE_CITY = `${environment.BASE_URL}admin/city`;
  BASE_DIST = `${environment.BASE_URL}admin/district`;
  //administrator portal builder
  ADMIN_PORTAL_BUILDER = `${environment.BASE_URL}admin/portalBuilder`;
  GET_PORTALBUILDER_DATA_USERID = `${environment.BASE_URL}admin/portalBuilder/get`;
  GET_PORTALBUILDER_DATA_ID = `${environment.BASE_URL}admin/portalBuilder`;
  CREATE_PORTALBUILDER = `${environment.BASE_URL}admin/portalBuilder/create`;
  UPDATE_PORTALBUILDER = `${environment.BASE_URL}admin/portalBuilder/update`;
  DELETE_PORTALBUILDER = `${environment.BASE_URL}admin/portalBuilder/delete`;

  //Configurator provider
  BASE_PROVIDER = `${environment.BASE_URL}admin/provider`;
  BASE_SCHEME_MANAGER = `${environment.BASE_URL}admin/schemeManager`;
  //BASe Currency
  BASE_CURRENCY = `${environment.BASE_URL}admin/currency`;

  ADMIN_GROUP_GET_WITH_PAGINATE = `${environment.BASE_URL}admin/group/get_with_paginate`;
  ADMIN_GROUP_CREATE = `${environment.BASE_URL}admin/group/create`;
  GET_ALL_GROUP = `${environment.BASE_URL}admin/group/getAllGroup`;
  GET_ALL_PERMISSION = `${environment.BASE_URL}admin/permission/get_with_paginate`;
  GET_ALL_PERMISSIONS = `${environment.BASE_URL}admin/permission/all`;
  GET_PERMISSIONS_DETAILS = `${environment.BASE_URL}admin/permission`;
  GET_ALL_MEMBERS = `${environment.BASE_URL}admin/user/all`;
  DELETE_GROUP = `${environment.BASE_URL}admin/group/delete`;
  ADMIN_GROUP_UPDATE = `${environment.BASE_URL}admin/group/update`;
  GET_GROUP_DETAILS = `${environment.BASE_URL}admin/group`;

  // employeeManagement
  // EMPLOYEE_MANAGEMENT_GETW_WITH_PAGINATE=`${environment.BASE_URL}admin/employeeManagement/get_with_paginate`;

  //role & Permission
  GET_ROLE = `${environment.BASE_URL}admin/roles/get_with_paginate`;
  GET_ALL_ROLE = `${environment.BASE_URL}admin/roles/get_all_role`;

  //Members
  GET_MEMBERS = `${environment.BASE_URL}admin/member/get_with_paginate`;

  FILE_UPLOAD = `${environment.BASE_URL}admin/upload`;
  EXCEL_FILE_UPLOAD = `${environment.BASE_URL}admin/upload/excel`;

  //KYC MANAGER RELATED APIS
  GET_KYC_LIST = `${environment.BASE_URL}admin/kyc/get_with_paginate`;
  GET_KYC_DETAILS = `${environment.BASE_URL}admin/kyc`;
  CREATE_KYC = `${environment.BASE_URL}admin/kyc/create`;
  UPDATE_KYC = `${environment.BASE_URL}admin/kyc/update`;
  DELETE_KYC = `${environment.BASE_URL}admin/kyc/delete`;

  // Language

  GET_LANGUAGE_LIST = `${environment.BASE_URL}admin/language/get_with_paginate`;
  GET_LANGUAGE_DETAILS = `${environment.BASE_URL}admin/language`;
  CREATE_LANGUAGE = `${environment.BASE_URL}admin/kyc/language`;
  UPDATE_LANGUAGE = `${environment.BASE_URL}admin/kyc/language`;
  DELETE_LANGUAGE = `${environment.BASE_URL}admin/kyc/language`;

  // App Configuration
  GET_APP_CONFIGURATION_DETAIL = `${environment.BASE_URL}admin/config`;
  // Api logs
  GET_API_LOGS = `${environment.BASE_URL}admin/log/get_with_paginate`;
  GET_CALLBACK_LOG = `${environment.BASE_URL}admin/log/get_by_type`;

  // search payment

  GET_PAYMENT_LIST = `${environment.BASE_URL}admin/log/get_by_type`;
  GET_RECONCILIATION_UPLOAD_LIST = `${environment.BASE_URL}admin/reconciliation/reconciled`;
  GET_RECONCILIATION_LIST = `${environment.BASE_URL}admin/reconciliation/get_with_paginate`;
  CREATE_RECONCILIATION = `${environment.BASE_URL}admin/reconciliation/create`;
  DOWNLOAD = `${environment.BASE_URL}admin/reconciliation/excel`;

  // GET_RECONCILIATION_ID=`${environment.BASE_URL}admin/reconciliation/get_with_paginate`
}
